import { Autocomplete, AutocompleteChangeDetails, AutocompleteChangeReason, TextField } from '@mui/material';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'lodash';
import { setTonnageNames, setTonnageNameSearchKeyword, setTonnageNameSearchResults, TonnageInputModel, tonnageInputSelector } from '../reducers/TonnageInputReducer';
import TonnageApi from '../api/TonnageApi';
import BaseResponse from '../../../app/BaseResponse';
import TonnageNameModel from '../models/TonnageNameModel';
import Utility from '../../../app/utility';

export interface AutoCompleteFilterOptionState {
    inputValue: string,
}

interface TonnageNameSelectorProp {
    triggerFocusInput: number,
    selectedTonnageId: string,
    currentVesselName: string,
    className?: string,
    onTonnageIdChange: (value: string, option: TonnageNameModel) => void,
    onVesselNameChange: (value: string) => void,
}

const TonnageNameSelector: React.FunctionComponent<TonnageNameSelectorProp> = (props) => {
    const dispatch = useDispatch();
    const tonnageViewData = useSelector(tonnageInputSelector);
    const filterLimit = 20;

    const textboxRef = React.createRef<HTMLInputElement>();

    useEffect(() => {
            textboxRef.current?.focus();
    }, [props.triggerFocusInput])

    const getCommandNumber = (value: string) => {
        var lastKey = value[value.length - 1];
        switch (lastKey) {
            case "!":
                return 1;
            case "@":
                return 2;
            case "#":
                return 3;
            case "$":
                return 4;
            case "%":
                return 5;
            case "^":
                return 6;
            case "&":
                return 7;
            case "*":
                return 8;
            case "(":
                return 9;
        }

        return 0;
    }

    return (
        <>
            {
                tonnageViewData.tonnageNames &&
                <Autocomplete
                    freeSolo
                    autoComplete
                    className={props.className ? props.className : ""}
                    options={tonnageViewData.tonnageNames}
                    inputValue={props.currentVesselName}
                    renderInput={(params) => <TextField {...params} label="Vessel Name" inputRef={textboxRef} />}
                    filterOptions={(options: Array<TonnageNameModel>, state: AutoCompleteFilterOptionState) => {
                        let inputValue = state.inputValue;

                        let searchResults = options.filter((option) => option.vesselName.toLowerCase().indexOf(inputValue.toLowerCase()) > -1);
                        searchResults = Utility.CloneObject(searchResults);

                        let index = 1;
                        _.each(searchResults, (item) => {
                            item.searchIndex = index;
                            index++;
                        });

                        if (tonnageViewData.tonnageNameSearchKeyword !== inputValue) {
                            dispatch(setTonnageNameSearchKeyword(inputValue));
                            dispatch(setTonnageNameSearchResults(searchResults));
                        }

                        return _.take(searchResults, filterLimit);
                    }}
                    getOptionLabel={(option: TonnageNameModel) => {
                        let dwt = option.dwt ? option.dwt : 0;
                        return "[" + option.searchIndex + "] " + option.vesselName + " [" + dwt + "]";
                    }}
                    onInputChange={(event: React.SyntheticEvent, value: string, reason: string) => {
                        let commandNumber = getCommandNumber(value);
                        if (commandNumber > 0) {
                            let selectedResult = tonnageViewData.tonnageNameSearchResults[commandNumber - 1];
                            if (selectedResult) {
                                props.onTonnageIdChange(selectedResult.id, selectedResult);
                            }
                        }

                        props.onVesselNameChange(value.toUpperCase());
                    }}
                    onChange={(event: React.SyntheticEvent<Element, Event>, value: string | TonnageNameModel | null, reason: AutocompleteChangeReason, details?: AutocompleteChangeDetails<TonnageNameModel> | undefined) => {
                        let option = value as TonnageNameModel;
                        if (option) {
                            props.onTonnageIdChange(option.id, option);
                        }
                    }}
                />
            }
        </>
    )
};

export default TonnageNameSelector;